import React from 'react'
import { GroupContainer } from '../GroupContainer'
import { SummaryItem } from '../SummaryItem'
import { useSummaryDetailsViewModel } from '../../../hooks/useSummaryDetailsViewModel'
import { useTranslation } from '../../../../../utils/convergence'
import { Divider } from '@afterpaytouch/core'
import styles from './style.module.css'

export const PaylaterSection = (): JSX.Element => {
  const { t } = useTranslation()
  const { financedItems, totalInterestAmount, totalAmount } = useSummaryDetailsViewModel()
  const isExpandable = financedItems.length >= 2

  return (
    <GroupContainer name={t('summary:payLater')} amount={totalAmount} expandable={isExpandable}>
      {financedItems.map((item) => (
        <SummaryItem key={item.id} name={item.name} amount={item.price} downPaymentAmount={item.downPaymentAmount} />
      ))}
      <Divider margin='Regular' />
      <SummaryItem name={t('summary:interest')} amount={totalInterestAmount} />
      <SummaryItem bold name={t('summary:planAmount')} amount={totalAmount} />
      <div className={styles.spacer} />
    </GroupContainer>
  )
}
